import { render, staticRenderFns } from "./GroupMembersBox.vue?vue&type=template&id=4467efc0&"
import script from "./GroupMembersBox.vue?vue&type=script&lang=js&"
export * from "./GroupMembersBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports